/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Category_Professional_FitInputs */

const en_matching_score_category_professional_fit = /** @type {(inputs: Matching_Score_Category_Professional_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professional match`)
};

const de_matching_score_category_professional_fit = /** @type {(inputs: Matching_Score_Category_Professional_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachliche Passung`)
};

/**
* | output |
* | --- |
* | "Professional match" |
*
* @param {Matching_Score_Category_Professional_FitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_category_professional_fit = /** @type {((inputs?: Matching_Score_Category_Professional_FitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Category_Professional_FitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_category_professional_fit(inputs)
	return en_matching_score_category_professional_fit(inputs)
});